import "../../../style/GeneralStyle.css";
import "../../../style/PhotoGeneralPage/PhotoGeneralPage.css";
import "../../../../common/UI/PhotoCircle/styles/photocircle.css";

import { useEffect, useState } from "react";
import { PhotoModalSecond } from "../../../../common/UI/Modal/molecules/ModalPhoto";
import { NavMenu } from "../../../../common/UI/NavMenu/organoids/NavMenu";
import {
  $GuideMode,
  $ReadenPhotoSlides,
  AddReadenPhotoSlide,
  setOpenVideo,
} from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import { GuideButtons } from "../../../../common/UI/GuideButtons/organoids/GuideButtons";
import { IForModal, Ipoint2D } from "../../../../common/interfaces";
import { titleName } from "../../../../common/function";
import { useStore } from "effector-react";
import "../../i18n";
import { useTranslation } from "react-i18next";

import MAIN4 from "../../../../common/assets/images/Cepr/PhotoPage/Станок.jpg";
import Circle1 from "../../../../common/assets/images/Cepr/PhotoPage/Circle empty.png";

import Cont_1_1 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_1_1.jpg";
import Cont_1_2 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_1_2.jpg";
import Cont_1_3 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_1_3.jpg";

import Cont_2_1 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_2_1.jpg";
import Cont_2_2 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_2_2.jpg";
import Cont_2_3 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_2_3.jpg";
import Cont_2_4 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_2_4.jpg";

import Cont_3_1 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_3_1.jpg";
import Cont_3_2 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_3_2.jpg";

import Cont_4_1 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_4_1.jpg";
import Cont_4_2 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_4_2.png";
import Cont_4_3 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_4_3.jpg";

import Cont_5_1 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_5_1.jpg";
import Cont_5_2 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_5_2.jpg";

import Cont_6_1 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_6_1.jpg";
import Cont_6_2 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_6_2.jpg";

import Cont_7_1 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_7_1.png";
import Cont_7_2 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_7_2.png";

import Cont_8_1 from "../../../../common/assets/images/Cepr/PhotoPage/Cont_8_1.png";
import { Tooltip } from "@mui/material";

export const PhotoPagePWA = () => {
  const [modalActiveSecond, setModalActiveSecond] = useState(false);
  const [spreadMenu, setSpreadMenu] = useState(false);
  const readenPhotos: any = useStore($ReadenPhotoSlides);
  const { t } = useTranslation();

  const PhotoPoints: Ipoint2D[] = [
    {
      id: "?",
      top: "27%",
      left: "48.5%",
      titletext: [""],
      title: t("PhotoPage.PhotoPage_Q.Title"),
      title_short: t("PhotoPage.PhotoPage_Q.Short_Title")!,
      content: [Cont_8_1],
      text: [""],
      list: [
        {
          title: t("PhotoPage.PhotoPage_Q.Text1.Title"),
          quotes: [
            t("PhotoPage.PhotoPage_Q.Text1.Text1"),
            t("PhotoPage.PhotoPage_Q.Text1.Text2"),
            t("PhotoPage.PhotoPage_Q.Text1.Text3"),
            t("PhotoPage.PhotoPage_Q.Text1.Text4"),
          ],
        },
        {
          title: t("PhotoPage.PhotoPage_Q.Text2.Title"),
          quotes: [
            t("PhotoPage.PhotoPage_Q.Text2.Text1"),
            t("PhotoPage.PhotoPage_Q.Text2.Text2"),
            t("PhotoPage.PhotoPage_Q.Text2.Text3"),
            t("PhotoPage.PhotoPage_Q.Text2.Text4"),
            t("PhotoPage.PhotoPage_Q.Text2.Text5"),
            t("PhotoPage.PhotoPage_Q.Text2.Text6"),
            t("PhotoPage.PhotoPage_Q.Text2.Text7"),
          ],
        },
      ],
    },
    {
      id: 1,
      top: "32%",
      left: "45%",
      titletext: [""],
      title: t("PhotoPage.PhotoPage_1.Title"),
      title_short: t("PhotoPage.PhotoPage_1.Short_Title")!,
      content: [Cont_1_1, Cont_1_2, Cont_1_3],
      damage: [
        [
          { height: 37, width: 53, posX: 48, posY: 10 },
          { height: 16, width: 25, posX: 20, posY: 67 },
          { height: 16, width: 25, posX: 52, posY: 76 },
        ],
        [{ height: 84, width: 64, posX: 29, posY: -4 }],
        [
          { height: 24, width: 10, posX: 9, posY: 34 },
          { height: 9, width: 54, posX: 19, posY: 16 },
          { height: 19, width: 10, posX: 70, posY: 30 },
        ],
      ],
      text: [t("PhotoPage.PhotoPage_1.Text")],
    },
    {
      id: 2,
      top: "39%",
      left: "48%",
      titletext: [""],
      title: t("PhotoPage.PhotoPage_2.Title"),
      title_short: t("PhotoPage.PhotoPage_2.Short_Title")!,
      content: [Cont_2_1, Cont_2_2, Cont_2_3, Cont_2_4],
      text: [t("PhotoPage.PhotoPage_2.Text")],
      damage: [
        [{ height: 42, width: 72, posX: 4, posY: 20 }],
        [
          { height: 26, width: 18, posX: 19, posY: 1 },
          { height: 22, width: 47, posX: 20, posY: 38 },
        ],
        [
          { height: 16, width: 43, posX: 10, posY: 26 },
          { height: 35, width: 69, posX: 32, posY: 60 },
        ],
        [{ height: 56, width: 87, posX: 7, posY: 19 }],
      ],
    },
    {
      id: 3,
      top: "42%",
      left: "65%",
      titletext: [""],
      title: t("PhotoPage.PhotoPage_3.Title"),
      title_short: t("PhotoPage.PhotoPage_3.Short_Title")!,
      content: [Cont_3_1, Cont_3_2],
      text: [t("PhotoPage.PhotoPage_3.Text")],
      damage: [
        [
          { height: 42, width: 37, posX: 30, posY: 2 },
          { height: 46, width: 36, posX: 35, posY: 45 },
        ],
        [],
      ],
    },
    {
      id: 4,
      top: "31%",
      left: "78%",
      titletext: [""],
      title: t("PhotoPage.PhotoPage_4.Title"),
      title_short: t("PhotoPage.PhotoPage_4.Short_Title")!,
      content: [Cont_4_1, Cont_4_2, Cont_4_3],
      text: [
        t("PhotoPage.PhotoPage_4.Text1"),
        t("PhotoPage.PhotoPage_4.Text2"),
      ],
      damage: [
        [{ height: 80, width: 48, posX: 2, posY: 6 }],
        [{ height: 64, width: 68, posX: 22, posY: 21 }],
        [{ height: 71, width: 98, posX: -2, posY: 21 }],
      ],
    },
    {
      id: 5,
      top: "64%",
      left: "75%",
      titletext: [""],
      title: t("PhotoPage.PhotoPage_5.Title"),
      title_short: t("PhotoPage.PhotoPage_5.Short_Title")!,
      content: [Cont_5_1, Cont_5_2],
      text: [t("PhotoPage.PhotoPage_5.Text")],
      damage: [
        [{ height: 78, width: 52, posX: 37, posY: 4 }],
        [{ height: 79, width: 50, posX: 20, posY: 4 }],
      ],
    },
    {
      id: 6,
      top: "18%",
      left: "69%",
      titletext: [""],
      title: t("PhotoPage.PhotoPage_6.Title"),
      title_short: t("PhotoPage.PhotoPage_6.Short_Title")!,
      content: [Cont_6_1, Cont_6_2],
      text: [t("PhotoPage.PhotoPage_6.Text")],
      damage: [[{ height: 90, width: 68, posX: 17, posY: 4 }], []],
    },
    {
      id: 7,
      top: "45%",
      left: "26%",
      titletext: [""],
      title: t("PhotoPage.PhotoPage_7.Title"),
      title_short: t("PhotoPage.PhotoPage_7.Short_Title")!,
      content: [Cont_7_1, Cont_7_2],
      text: [t("PhotoPage.PhotoPage_7.Text")],
      damage: [[{ height: 47, width: 45, posX: 21, posY: 32 }], []],
    },
  ];
  let allPoints: Ipoint2D[] = PhotoPoints;

  const [forModal, setForModal] = useState<IForModal>({
    title: "",
    content: [""],
    text: [""],
    list: [{ title: "", quotes: [""] }],
  });

  titleName(t("BrowserLine.PhotoPage"));

  function detectMob() {
    return window.innerWidth <= 800 || window.innerHeight <= 600;
  }

  function iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  useEffect(() => {
    if ($GuideMode.getState()) {
      if (readenPhotos === 8) {
        setOpenVideo(true);
      }
    }
  }, [readenPhotos]);

  return (
    <div className="PhotoPage">
      <img src={t("PhotoPage.Picture")!} alt="" className="PhotoPage_Logo" />
      <div className="PhotoPage_Block">
        <div className="Page_BlockTitlePhone Page_BlockTitle">
          {t("PhotoPage.Title")}
        </div>
        <div className="PhotoPageCepr_BlockSecond">
          <div
            className={
              spreadMenu
                ? "PhotoPage_BlockSecond_spreadMenu_One"
                : "PhotoPage_BlockSecond_spreadMenu_Two"
            }
          >
            <img src={MAIN4} className="PhotoPage_BlockSecond_img" alt="" />
            {allPoints.slice(0, readenPhotos + 1).map((e, i) => {
              return !iOS() ? (
                <Tooltip
                  title={!detectMob() ? e.title : ""}
                  key={i}
                  children={
                    <div
                      className="lastVariantButton"
                      onClick={() => {
                        setForModal({
                          title: e.title,
                          content: e.content,
                          text: e.text,
                          list: e.list,
                          damage: e.damage,
                        });
                        setModalActiveSecond(true);
                        AddReadenPhotoSlide();
                      }}
                      style={{ top: e.top, left: e.left }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          // zIndex: 2,
                          textAlign: "center",
                          color: "white",
                          left: "0",
                          right: "0",
                          fontWeight: 700,
                        }}
                      >
                        {e.id}
                      </span>
                      <img
                        className="withWaves"
                        style={{ height: "auto", width: "100%" }}
                        alt=""
                        src={Circle1}
                      ></img>
                    </div>
                  }
                />
              ) : (
                <div
                  className="lastVariantButton"
                  onClick={() => {
                    setForModal({
                      title: e.title,
                      content: e.content,
                      text: e.text,
                      list: e.list,
                      damage: e.damage,
                    });
                    setModalActiveSecond(true);
                    AddReadenPhotoSlide();
                  }}
                  style={{ top: e.top, left: e.left }}
                >
                  <span
                    style={{
                      position: "absolute",
                      // zIndex: 2,
                      textAlign: "center",
                      color: "white",
                      left: "0",
                      right: "0",
                      fontWeight: 700,
                    }}
                  >
                    {e.id}
                  </span>
                  <img
                    className="withWaves"
                    style={{ height: "auto", width: "100%" }}
                    alt=""
                    src={Circle1}
                  ></img>
                </div>
              );
            })}
          </div>
        </div>
        <GuideButtons
          spreadMenu={spreadMenu}
          setSpreadMenu={setSpreadMenu}
          ReadenMarkers={readenPhotos}
          AddReadenMarker={AddReadenPhotoSlide}
          markers={allPoints}
          setForModal={setForModal}
          setModalActive={setModalActiveSecond}
        />
        <NavMenu
          nextUrl={"/pwa/video"}
          backUrl={"/pwa"}
          visibleFlag={"/pwa/photo"}
        />
      </div>
      <PhotoModalSecond
        text={forModal.text}
        title={forModal.title}
        content={forModal.content}
        active={modalActiveSecond}
        setActive={setModalActiveSecond}
        list={forModal.list}
        damage={forModal.damage}
      />
    </div>
  );
};
